import React, {useEffect, useState} from 'react'
import styled from 'styled-components'
import FAQs from './FAQs'
import Glossary from './glossary/Glossary'
import {useSearchParams} from 'react-router-dom'
import Tabs from '../../commons/Tabs'


const TripleTab = () => {
  const [tabToShow, setTabToShow] = useState<0 | 1 | 2>(0)
  const [urlSearchParams] = useSearchParams()
  const keywords = (urlSearchParams.get('ricerca') || '').trim().split(' ')
  const goTo = urlSearchParams.get('go-to')

  useEffect(() => {
    // Se è stata effettuata una ricerca, scrollo sulle faq
    const section = document.querySelector( '#double-tab' )
    if(keywords[0]) {
      section && section.scrollIntoView()
    } else if (goTo === 'glossary'){
      setTabToShow(1)
      section && section.scrollIntoView()
    }
  }, [])

  return (
    <Row id={'double-tab'}>
      <LinksContainer>
        <Tabs
          ariaLabel={'Assistenza'}
          activeIndex={tabToShow}
          onChange={(i) => setTabToShow(i as 0 | 1)}
          items={[
            { id: 'faq', label: 'FAQ', content: <FAQs keywords={keywords} /> },
            { id: 'glossario', label: 'GLOSSARIO', content: <Glossary keywords={keywords} /> },
          ]}
        />
      </LinksContainer>
    </Row>
  )
}

// region Style
const Row = styled.div`
  display: flex;
  flex-wrap: wrap;
  margin-right: -15px;
  margin-left: -15px;
`
const LinksContainer = styled.div`
  text-align: center !important;
  padding-bottom: 3rem !important;
  padding-top: 3rem !important;
  flex: 0 0 100%;
  max-width: 100%;
  position: relative;
  width: 100%;
  padding-right: 15px;
  padding-left: 15px;
`
// endregion

export default TripleTab
